import {put, takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {answerQuestion} from "../actions";
import {addLives} from "../../player/actions";

export function* watchAnswerQuestion() {
    yield takeEvery(getType(answerQuestion), function* ({payload}: ActionType<typeof answerQuestion>) {
        if (!payload.isRight && payload.attempts < 0) {
            yield put(addLives(-1, "answered_question_wrong"));
        }
    });
}